import { render } from "./FormatGroupEdit.vue?vue&type=template&id=fe730170"
import script from "./FormatGroupEdit.vue?vue&type=script&lang=js"
export * from "./FormatGroupEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__